module.exports = function() {
  return new Worker(__webpack_public_path__ + "33503b004a7856dddc22.worker.js");
};